import { useLazyQuery } from "@apollo/client/react";import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { GET_DOCUMENTOS_RI } from '../../../../data/graphQL/queries/MisTareas/getDocumentosRI';

import fileDownload from 'js-file-download';
import VisibilityIcon from '@mui/icons-material/Visibility';

import './desktopMisTareasDocuments.scss';
import DocumentViewer from '../../../../components/DocumentViewer';

export const DesktopMisTareasDocuments = ({ setChildrenAction, setHeaderContent, setFooterContent }) => {
  const location = useLocation();
  const stateData = location.state.data;

  const [rows, setRows] = useState([]);

  // visualización de archivo
  const [filePreview, setFilePreview] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  const initialColumns = [
  {
    field: 'tipoDocumento',
    headerAlign: 'left',
    headerName: 'Tipo'
  },
  {
    field: 'titulo',
    headerAlign: 'left',
    align: 'left',
    headerName: 'Documento'
  },
  {
    flex: 0.05,
    align: 'right',
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <VisibilityIcon onClick={() => handlePreview(row)} className='edit-icon' sx={{ padding: 0, margin: 0 }} />);

    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), null);

  const [getDocumentosRI, { data: documentosData, loading: documentosLoading }] = useLazyQuery(GET_DOCUMENTOS_RI, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!documentosData) return;
    setRows(documentosData.documentosRI.valorEsperado);
  }, [documentosData]);  

  useEffect(() => {
    if (!documentosLoading) {
      getDocumentosRI({ variables: { idDatosGeneralesRI: parseInt(stateData?.idDatosGeneralesRI, 10) } });
    }
  }, []);

  const handlePreview = (row) => {
    const data = {
      archivo: row.archivo,
      extension: row.extension,
      titulo: row.titulo,
      contentType: row.contentyType
    };

    setFilePreview(data);
    setOpenPreview(true);
  };

  const handleRowClick = (params) => {
    handlePreview(params.row);
  };

  return (
    <>
            <div className='general'>            
                <h3>Paciente / {stateData?.paciente}</h3>
                <DataGridGenerico
          columns={columns}
          rows={rows}
          toolbar={false}
          loading={documentosLoading}
          onRowClick={handleRowClick} />
        
            </div>

            {openPreview && <DocumentViewer data={filePreview} setOpenDlg={setOpenPreview} download={true} />}
        </>);


};